
import { defineComponent, watch } from "vue";
import { CurrencyDisplay, useCurrencyInput, ValueScaling } from 'vue-currency-input'
import { EventInput } from "@/models";

export default defineComponent({
    emits: ["changed"],
    props: {
        modelValue: Number,
        modelModifiers: {
            default: () => ({}),
        },
        placeholder: String,
        inputClass: Object,
        disabled: {
            type: Boolean,
            default: false,
        },
        precision: Number,
        locale: String
    },
    setup(props) {
        const { inputRef, setValue } = useCurrencyInput({
            currencyDisplay: CurrencyDisplay.hidden,
            hideCurrencySymbolOnFocus: false,
            hideGroupingSeparatorOnFocus: false,
            hideNegligibleDecimalDigitsOnFocus: false,
            useGrouping: true,
            // valueScaling: ValueScaling.precision,
            currency: 'USD',
            precision: props.precision,
            locale: props.locale
        })
        watch(
            () => props.modelValue, // Vue 2: props.value
            (value) => {
                setValue(value ?? 0)
            }
        )
        return { inputRef }
    },
    methods: {
        onChanged($event: EventInput) {
            this.$emit("changed", $event);
        }
    }
});
